import axios from 'axios'
import moment from 'moment'

import store from '@/stores'

import MensagemServico from './MensagemServico'
import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL
const mensagemServico = new MensagemServico()

class AgendaServico extends Servico {
  constructor() {
    super('agenda')
  }

  recuperarAgendas(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/horarios`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  criarAgenda(data) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/horarios`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarAgenda(id, data) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${id}/horarios`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  pesquisaDatasFuturas(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/pesquisaDatasFuturas`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  checarDisponibilidade(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/checarDisponibilidade`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarMultiplos(dataArray) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/adicionarMultiplosAgendamentos`, dataArray)
      .then((result) => {
        store.setCarregando()
        mensagemServico.alerta(result.data.msg)
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        let msgErro = ''
        const tipoErro = err.response.data.tipoErro
        if (tipoErro === 'limiteExcedido') {
          msgErro = err.response.data.err
        } else {
          msgErro = 'As datas não estão disponíveis: '
          const datasErro = err.response.data.datasNaoDisponiveis
          const datasErroTexto = []

          datasErro.forEach((d) => {
            const dataTexto = moment(d).format('DD/MM/YYYY')
            datasErroTexto.push(dataTexto)
          })

          msgErro += datasErroTexto.join(', ')
        }

        const erro = {
          title: `${err.response.status} - ${err.response.data.msg}`,
          content: msgErro,
        }

        mensagemServico.alerta(erro.content, erro.title)
      })
  }

  pesquisaDatasFuturasProfissional(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/pesquisaDatasFuturasProfissional`, {
        params: data,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  gerarDiasFuturosRepeticao(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/gerarDiasFuturos`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  checarDisponibilidadeAgenda(data) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/checarDisponibilidade`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarMultiplosAgendamentos(dataArray) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/adicionarMultiplosAgendamentos`, dataArray)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioPagamentoProfissional(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/relatorioPagamentoProfissional`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioAtendimentoProfissional(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/relatorioAtendimentoProfissional`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        this.verificarErro(err)
      })
  }
}

export default AgendaServico
